import { useEffect, useState } from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from '@mui/material';

const ContainerListDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled, isFetchingContainerList, containerList, getListContainer} = props;

    const theme = useTheme();

    const [containerListData, setContainerListData] = useState([]);
    const [inputValue, setInputValue] = useState("");
    

    useEffect(() => {
        getListContainer();
    }, [])

    useEffect(() => {
        if (containerList?.length > 0) {
            setContainerListData(containerList);
        }
    }, [containerList])


    const handleChange = (value) => {
        onChange(value);
    }

    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={containerListData}
                getOptionLabel={(option) => `${option?.container_number}` || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={value}
                loading={isFetchingContainerList}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Container not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search container"
                        slotProps={{
                            input: {
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {isFetchingContainerList ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default ContainerListDropdownComponent